import * as React from 'react';
import ApplyState from './applyStatus';
import ApplyStep from './applyStep';
import { PaccApplyResultVO } from '@domain/vo/phs/pacc/results/PaccApplyResultVO';
import classNames from 'classnames/bind';
import styles from './testSummary.module.scss';

const cx = classNames.bind(styles);

interface TestSummaryProps {
  applyResult: PaccApplyResultVO;
}

const TestSummary = ({ applyResult }: TestSummaryProps) => {
  return (
    <div className={cx('testSummaryWrap')}>
      {/* [D] 종합 응시 결과 */}
      <ApplyState applyResult={applyResult} />

      {/* [D] 응시 과정별 결과 */}
      <ApplyStep applyResult={applyResult} />
    </div>
  );
};

export default TestSummary;
